module.exports = __webpack_public_path__ + "037286e16d1ecd61c618a1b07e5eab47.svg";